import { useEffect, useRef } from 'react';

import { useAppContext } from './useAppContext';
import { useSearchStore } from './stores/search/useSearchStore';

/**
 * Hook that handles resetting search store fields when currency or measurement system changes.
 * When currency changes, it resets the price filter.
 * When measurement system changes, it resets surface-related filters (plot, total surface).
 *
 * @note This hook should only be used inside the SearchEffectsProvider component.
 */

export const useOptionChangedEffect = (): void => {
  const {
    options: { currency, measurementSystem },
  } = useAppContext();
  const initialOptions = useRef({ currency, measurementSystem });

  const setPrice = useSearchStore((state) => state.setPrice);
  const setPlotSurface = useSearchStore((state) => state.setPlotSurface);
  const setTotalSurface = useSearchStore((state) => state.setTotalSurface);

  useEffect(() => {
    if (initialOptions.current.currency !== currency) {
      setPrice(undefined);
      initialOptions.current.currency = currency;
    }
    if (initialOptions.current.measurementSystem !== measurementSystem) {
      setPlotSurface(undefined);
      setTotalSurface(undefined);
      initialOptions.current.measurementSystem = measurementSystem;
    }
  }, [measurementSystem, currency, setPrice, setPlotSurface, setTotalSurface]);
};
